var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.201.647a.701.701 0 00-1.04 0l-6.57 7.035-2.835-3.036a.701.701 0 00-1.04 0 .827.827 0 000 1.114L4.07 9.353a.71.71 0 00.52.23.71.71 0 00.52-.23l7.09-7.592a.828.828 0 000-1.114z",
    fill: "#fff"
  })));
}

export default SvgCheck1;